import styled from 'styled-components';
import { collectPackageInfo } from '../../collectPackageInfo';
collectPackageInfo('Fade/Fade');
var gradients = {
  top: 'radial-gradient(200% 200% at 50% -100%, rgba(0, 0, 0, 0.8) 0%, rgba(0, 0, 0, 0) 100%)',
  bottom: 'radial-gradient(200% 200% at 50% 200%, rgba(0, 0, 0, 0.8) 0%, rgba(0, 0, 0, 0) 100%)'
};
export var Fade = /*#__PURE__*/styled.div.withConfig({
  componentId: "plasma__sc-uhaeek-0"
})(["position:fixed;top:0;left:0;right:0;bottom:0;z-index:999;background:", ";"], function (_ref) {
  var _ref$placement = _ref.placement,
      placement = _ref$placement === void 0 ? 'bottom' : _ref$placement;
  return gradients[placement];
});